import i18next from 'i18next';
import type { ProgressStateType } from '../../../../../../data/vehicles/useVehicle';
import Badge from '../../../../../../styled-components/components/Badge';

export const progressStateTypesLabel = (type: ProgressStateType) => {
  switch (type) {
    case 'urn:wayke:vehicle:progress-state:pre-calculation':
      return i18next.t('shared.progress.types.preCalculation', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    case 'urn:wayke:vehicle:progress-state:assessment':
      return i18next.t('shared.progress.types.assessment', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    case 'urn:wayke:vehicle:progress-state:purchase-calculation':
      return i18next.t('shared.progress.types.purchaseCalculation', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    case 'urn:wayke:vehicle:progress-state:purchase-contract':
      return i18next.t('shared.progress.types.purchaseContract', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    case 'urn:wayke:vehicle:progress-state:incoming':
      return i18next.t('shared.progress.types.incoming', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    case 'urn:wayke:vehicle:progress-state:receiving-inspection':
      return i18next.t('shared.progress.types.receivingInspection', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    case 'urn:wayke:vehicle:progress-state:workshop':
      return i18next.t('shared.progress.types.workshop', { ns: 'salesAndPurchasingVehiclesItem' });
    case 'urn:wayke:vehicle:progress-state:marketing':
      return i18next.t('shared.progress.types.marketing', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    case 'urn:wayke:vehicle:progress-state:idle':
      return i18next.t('shared.progress.types.idle', { ns: 'salesAndPurchasingVehiclesItem' });
    case 'urn:wayke:vehicle:progress-state:state-report':
      return i18next.t('shared.progress.types.stateReport', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    case 'urn:wayke:vehicle:progress-state:self-declaration':
      return i18next.t('shared.progress.types.selfDeclaration', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    case 'urn:wayke:vehicle:progress-state:planning':
      return i18next.t('shared.progress.types.planning', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    case 'urn:wayke:vehicle:progress-state:auction':
      return i18next.t('shared.progress.types.auction', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    case 'urn:wayke:vehicle:progress-state:ready-for-sale':
      return i18next.t('shared.progress.types.readyForSale', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    case 'urn:wayke:vehicle:progress-state:failed':
      return i18next.t('shared.progress.types.failed', { ns: 'salesAndPurchasingVehiclesItem' });
    case 'urn:wayke:vehicle:progress-state:sold':
      return i18next.t('shared.progress.types.sold', { ns: 'salesAndPurchasingVehiclesItem' });
    default:
      return i18next.t('unknown', { ns: 'validation' });
  }
};

export const progressStateTypesTimelineType = (type: ProgressStateType) => {
  switch (type) {
    case 'urn:wayke:vehicle:progress-state:pre-calculation':
    case 'urn:wayke:vehicle:progress-state:assessment':
    case 'urn:wayke:vehicle:progress-state:purchase-calculation':
    case 'urn:wayke:vehicle:progress-state:purchase-contract':
    case 'urn:wayke:vehicle:progress-state:incoming':
    case 'urn:wayke:vehicle:progress-state:receiving-inspection':
    case 'urn:wayke:vehicle:progress-state:workshop':
    case 'urn:wayke:vehicle:progress-state:marketing':
    case 'urn:wayke:vehicle:progress-state:idle':
    case 'urn:wayke:vehicle:progress-state:ready-for-sale':
    case 'urn:wayke:vehicle:progress-state:failed':
    case 'urn:wayke:vehicle:progress-state:sold':
    case 'urn:wayke:vehicle:progress-state:state-report':
    case 'urn:wayke:vehicle:progress-state:self-declaration':
      return 'progress';
    default:
      return undefined;
  }
};

const progressStateTypesBadgeTone = (type: ProgressStateType) => {
  switch (type) {
    case 'urn:wayke:vehicle:progress-state:pre-calculation':
    case 'urn:wayke:vehicle:progress-state:assessment':
    case 'urn:wayke:vehicle:progress-state:purchase-calculation':
    case 'urn:wayke:vehicle:progress-state:purchase-contract':
    case 'urn:wayke:vehicle:progress-state:incoming':
    case 'urn:wayke:vehicle:progress-state:receiving-inspection':
    case 'urn:wayke:vehicle:progress-state:workshop':
    case 'urn:wayke:vehicle:progress-state:marketing':
    case 'urn:wayke:vehicle:progress-state:idle':
    case 'urn:wayke:vehicle:progress-state:ready-for-sale':
    case 'urn:wayke:vehicle:progress-state:failed':
    case 'urn:wayke:vehicle:progress-state:sold':
    case 'urn:wayke:vehicle:progress-state:state-report':
    case 'urn:wayke:vehicle:progress-state:self-declaration':
      return 'contrast';
    default:
      return undefined;
  }
};

interface ProgressStateTypesBadgeProps {
  type: ProgressStateType;
}

export const ProgressStateTypesBadge = ({ type }: ProgressStateTypesBadgeProps) => (
  <Badge tone={progressStateTypesBadgeTone(type)}>{progressStateTypesLabel(type)}</Badge>
);
